import { notification } from 'ant-design-vue'

export const err500 = (msg?: string) => notification.warning({
  key: '500',
  message: `接口报错`,
  description: (
    <>
      <p>检测到接口错误：${msg}</p>
      <p>
          错误码<span style="color:red"> 500 </span>
          ：此类错误内容常见于后台panic，请先查看后台日志，如果影响您正常使用可强制登出清理缓存
      </p>
    </>
  ),
})

export const err404 = (msg?: string) => {
  return notification.warning({
    key: '404',
    message: `接口报错`,
    description: (
      <>
        <p>检测到接口错误：{msg}</p>
        <p>
          错误码<span style="color:red"> 404 </span>
          ：此类错误多为接口未注册（或未重启）或者请求路径（方法）与api路径（方法）不符--如果为自动化代码请检查是否存在空格
        </p>
      </>
    ),
  })
}

export const errReq = (msg?: string) => notification.warning({
  key: 'error',
  message: `接口报错`,
  description: (
    <>
      <p>检测到请求错误</p>
      <p>{msg}</p>
    </>
  ),
})
